(function () {
    'use strict';

    angular
            .module('app')
            .controller('RegistrationController', RegistrationController);

    function RegistrationController(UserService, $state, $scope, $rootScope, FlashService, PasswordService) {
        var vm = this;

        vm.userData = { FirstName: "", LastName: "", Email: "", Password: "", ConfirmPassword: "", AgreedToPolicy: false };
        vm.registerUser = registerUser;
        vm.isWebApiCallFailed = false;
        vm.error = "";

        function registerUser(isFormInvalid) {
            vm.isWebApiCallFailed = false;
            if (!isFormInvalid) {
                UserService.registerUser(vm.userData).then(function (data) {
                    $rootScope.messageData = { code: "RegistrationSuccessful", title: "Registration Successful" };
                    $state.go('displayMessage');
                }, function (error, status) {
                    vm.isWebApiCallFailed = true;
                    var errors = [];
                    if (!error) {
                        errors.push('Server Error. Please contact your system administrator');
                    }
                    else {
                        for (var key in error.ModelState) {
                            for (var i = 0; i < error.ModelState[key].length; i++) {
                                errors.push(error.ModelState[key][i]);
                            }
                        }
                    }
                    vm.error = errors;
                });
            }
        }

        $scope.$watch('vm.userData', function (newObject, oldObject) {
            if (newObject.Password !== oldObject.Password) {
                vm.passwordStrength = PasswordService.getStrength(newObject.Password);
                vm.passwordProgressStyle = { width: vm.passwordStrength + '%' };
                if (vm.isPasswordWeak()) {
                    $scope.registerform.password.$setValidity('strength', false);
                } else {
                    $scope.registerform.password.$setValidity('strength', true);
                }
                //console.log(vm.passwordProgressStyle);
            }
        }, true);

        vm.isPasswordWeak = function () {

            return vm.passwordStrength < 40;
        }

        vm.isPasswordOk = function () {

            return vm.passwordStrength >= 40 && vm.passwordStrength <= 70;
        }

        vm.isPasswordStrong = function () {

            return vm.passwordStrength > 70;
        }

    }

})();